<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-generic-modal [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   [primaryActionEnabled]="isValid"
                   (primaryActionEvent)="save()"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <app-input-text #shipToPartyNameInput
                        label="Ship to party name"
                        placeholder="Please, write a new ship to party name"
                        baseCypressTag="business-settings-ship-to-party-modal-name"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [maxLength]="100"
                        [validators]="validators.name"
                        [messages]="nameMessages"
                        (inputValueChange)="nameInputChange($event)"></app-input-text>

        <app-input-text #shipToPartyCodeInput
                        label="Ship to party code"
                        placeholder="Please, write a new ship to party code, e.g. 29333277"
                        baseCypressTag="business-settings-ship-to-party-modal-code"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [maxLength]="8"
                        [validators]="validators.code"
                        [messages]="codeMessages"
                        (inputValueChange)="codeInputChange($event)"></app-input-text>

        <div class="ship-to-party-parent-info-section">
            <div class="ship-to-party-parent-info-alphacode3">
                <div class="modal-info-label"
                     data-cy="business-settings-ship-to-party-parent-label">Alphacode 3</div>
                <div class="modal-info-value"
                     data-cy="business-settings-ship-to-party-parent-info">{{$safeNavigationMigration(state?.originalElement?.displayParentCode) | undefinedValue}}</div>
            </div>
        </div>

        <app-active-input [entityName]="ENTITY_NAME" [state]="$safeNavigationMigration(state?.isActive)"
                          (checkState)="setActiveInputState($event)"></app-active-input>
    </div>

</app-generic-modal>
